import { Component } from '@angular/core';

@Component({
  selector: 'app-team-profile-skeleton',
  templateUrl: './team-profile-skeleton.component.html',
  standalone: false,
})
export class TeamProfileSkeletonComponent {}
